import { AssetLoader } from '@/shared/utils';
import GemiusEmitter from './gemius-emitter';

export default async ({ $deferredLoader, $services, $stats }) => {
  const info = $services.resolve('info');

  await info.fetch();
  const { hitCollectorHost, scriptIdentifier } = info.gemiusInfo || {};

  if (!hitCollectorHost || !scriptIdentifier) {
    return;
  }

  window.pp_gemius_identifier = scriptIdentifier;
  window.pp_gemius_id = scriptIdentifier;
  window.pp_gemius_use_cmp = true;
  window.pp_gemius_cmp_timeout = 20000;

  window.gemius_pending = (i) => {
    window[i] = window[i] || function () {
      const x = window[i + '_pdata'] = window[i + '_pdata'] || []; // eslint-disable-line
      x[x.length] = arguments; // eslint-disable-line
    };
  };

  window.gemius_pending('gemius_hit');
  window.gemius_pending('gemius_event');
  window.gemius_pending('pp_gemius_hit');
  window.gemius_pending('pp_gemius_event');

  const emitter = new GemiusEmitter($stats);
  $stats.registerEmitter(emitter);

  Promise.all([
    $deferredLoader.appReady.promise,
    $deferredLoader.oneTrust.promise,
  ])
    .then(() => new AssetLoader().load([
      { id: 'gemius', src: `${hitCollectorHost}/xgemius.js` },
    ], { async: true, defer: true }))
    .then(() => {
      emitter.activate();
    })
    .catch(() => {});
};
